import './app.scss';

import angular from 'angular';
import thirdPartyModules from './thirdPartyModules';
import appConfig from './app.config';
import cardFlow from './components/cardFlow';
import imageSlider from './components/imageSlider';
import scheduler from './components/scheduler';
import subTables from './components/subTables';
import utilDropdown from './components/utilDropdown';
import Routing from './routes';

import Services from './core/services';
import { Filters } from 'Utils/filters';
import Admin from './components/admin';

import Dashboard from './components/dashboard';

import Base from './components/base';

import Profile from './components/profile/Profile.module';

import WhiteListedDomainsConfig from './components/base/configs/WhiteListedDomainsConfig';
import SessionService from './components/base/SessionService';
import PermissionsDirective from './components/base/PermissionsDirective';

import dateTimeRangePicker from './components/dateTimeRangePicker';
import ReportsModule from './components/reports';

import uiSelectDecorator from 'Utils/uiSelectDecorator';
import AppComponent from './AppComponent';
import AppService from './AppService';
import ngTouchevents from './components/ngTouchevents';
import pcIconDirective from './components/pcIconDirective';

import 'Images/logo.svg';

export default angular.module('petroCloud', [
  ...thirdPartyModules,
  Services,
  Filters,
  Routing,
  Admin,
  Base,
  Dashboard,
  Profile,
  cardFlow,
  imageSlider,
  scheduler,
  ReportsModule,
  subTables,
  utilDropdown,
  ngTouchevents,
  dateTimeRangePicker,
])
  .config(appConfig)
  .config(WhiteListedDomainsConfig)
  .decorator(uiSelectDecorator.name, uiSelectDecorator.decorator)
  .service('AppService', AppService)
  .service('SessionService', SessionService)
  .directive('permissions', PermissionsDirective)
  .directive('pcIcon', pcIconDirective)
  .component(AppComponent.name, AppComponent)
  .name;
